// Mock data for Toronto Refund website

export const navLinks = [
  { name: 'Home', href: '#home' },
  { name: 'Why Us', href: '#why-us' },
  { name: 'How It Works', href: '#how-it-works' },
  { name: 'Testimonials', href: '#testimonials' },
  { name: 'FAQ', href: '#faq' }
];

export const trustedLogos = [
  { name: 'Company 1', url: 'https://optim.tildacdn.com/tild3364-3838-4665-a461-376239303738/-/resize/440x/-/format/webp/Frame_8.png.webp' },
  { name: 'Company 2', url: 'https://optim.tildacdn.com/tild3731-6163-4661-b939-343638616539/-/resize/440x/-/format/webp/Frame_22.png.webp' },
  { name: 'Company 3', url: 'https://optim.tildacdn.com/tild6433-6233-4037-b237-313662383138/-/resize/440x/-/format/webp/Frame_3.png.webp' },
  { name: 'Company 4', url: 'https://optim.tildacdn.com/tild3065-3236-4664-b630-353230646262/-/resize/440x/-/format/webp/Frame_5.png.webp' },
  { name: 'Company 5', url: 'https://optim.tildacdn.com/tild3031-3865-4730-b132-353731326533/-/resize/440x/-/format/webp/Frame_7.png.webp' },
  { name: 'Company 6', url: 'https://optim.tildacdn.com/tild3632-6433-4535-a164-303166643636/-/resize/440x/-/format/webp/Frame_9.png.webp' },
  { name: 'Company 7', url: 'https://optim.tildacdn.com/tild6337-3762-4130-a330-643237383539/-/resize/440x/-/format/webp/Frame_10.png.webp' },
  { name: 'Company 8', url: 'https://optim.tildacdn.com/tild3435-3238-4738-b833-643230366336/-/resize/440x/-/format/webp/Frame_11.png.webp' },
  { name: 'Company 9', url: 'https://optim.tildacdn.com/tild6638-6631-4765-a634-333664653930/-/resize/440x/-/format/webp/Frame_12.png.webp' },
  { name: 'Company 10', url: 'https://optim.tildacdn.com/tild3132-6166-4235-b131-326465323730/-/resize/440x/-/format/webp/Frame_13.png.webp' },
  { name: 'Company 11', url: 'https://optim.tildacdn.com/tild3736-3062-4033-b134-333530653761/-/resize/440x/-/format/webp/Frame_14.png.webp' },
  { name: 'Company 12', url: 'https://optim.tildacdn.com/tild3138-3462-4634-b333-373633616663/-/resize/440x/-/format/webp/Frame_15.png.webp' },
  { name: 'Company 13', url: 'https://optim.tildacdn.com/tild3039-6531-4438-a361-326436656565/-/resize/440x/-/format/webp/Frame_20.png.webp' },
  { name: 'Company 14', url: 'https://optim.tildacdn.com/tild6131-3836-4538-b737-383539643330/-/resize/440x/-/format/webp/Frame_19.png.webp' },
  { name: 'Company 15', url: 'https://optim.tildacdn.com/tild6265-3030-4861-b134-393831326366/-/resize/440x/-/format/webp/Frame_18.png.webp' }
];

export const approachSteps = [
  {
    icon: 'PieChart',
    title: 'Preliminary Case Assessment',
    description: 'Objective: Analyze available data and past case records to evaluate the chances of a successful outcome.'
  },
  {
    icon: 'FileText',
    title: 'Gather The Evidence',
    description: 'Collect all relevant evidence and records to build a strong case foundation and ensure its progress.'
  },
  {
    icon: 'Shield',
    title: 'Confront The Entities',
    description: 'Identify and engage with all parties involved in the unauthorized transfer of your assets to recover losses and seek accountability.'
  },
  {
    icon: 'CreditCard',
    title: 'Get Your Money Back',
    description: 'With a proven track record, we are committed to exhausting all efforts to recover your assets and secure the compensation you deserve.'
  }
];

export const features = [
  {
    icon: 'Database',
    title: 'Diversity',
    description: 'At our company, inclusivity is promoted by embracing diverse perspectives and innovative approaches to address everyday challenges.'
  },
  {
    icon: 'Briefcase',
    title: 'Professionalism',
    description: 'High standards of professionalism are maintained in all aspects of our work, ensuring that our staff meets these expectations.'
  },
  {
    icon: 'Users',
    title: 'Integrity',
    description: 'Strong relationships are fostered with clients who share our values of integrity, ensuring a perfect alignment in our work.'
  },
  {
    icon: 'Search',
    title: 'Transparency',
    description: 'Transparency is prioritized in our hiring practices and internal processes, providing clients with the insights they need to trust us.'
  }
];

export const howItWorksSteps = [
  {
    number: '1',
    title: 'Analysis and audit',
    description: 'Perform a comprehensive evaluation of your case to assess its likelihood of success.'
  },
  {
    number: '2',
    title: 'Prepare documents',
    description: 'Collect all relevant evidence and materials necessary to establish a strong foundation for your case.'
  },
  {
    number: '3',
    title: 'Complete the Process',
    description: 'Engage with all involved parties and work diligently to recover your assets and secure the compensation you deserve.'
  }
];

export const testimonials = [
  {
    quote: "I was scammed out of $200,000 in an online investment-my entire life savings! I was devastated. But thanks to the incredible ChargebackCanada team and Mr. Josh personally, I got every penny back. Every Sunday, I pray for the health of each team member who worked on my case.",
    name: "John Peterson",
    avatar: "https://optim.tildacdn.net/tild3137-3434-4766-b364-643735613661/-/cover/100x100/center/center/-/format/webp/__6.jpeg.webp"
  },
  {
    quote: "Martha has been handling my case against Option 500 and Capital Group. After feeling nothing but fear and mistrust, I can now say only great things about ChargebackCanada and the way they've guided me through this challenging process.",
    name: "Adam Lytt",
    avatar: "https://optim.tildacdn.net/tild3734-3633-4863-b466-626131326164/-/cover/100x100/center/center/-/format/webp/__10.jpeg.webp"
  },
  {
    quote: "Your expertise and unwavering support were incredible. I highly recommend your services to anyone in need of professional guidance.",
    name: "Michael Andrews",
    avatar: "https://optim.tildacdn.net/tild3466-3264-4663-b632-366131663530/-/cover/100x100/center/center/-/format/webp/__16.jpeg.webp"
  },
  {
    quote: "ChargebackCanada helped me recover $51,000 from an $123,400 fraud. I'm so grateful for their amazing work-thank you!",
    name: "Sarah Johnson",
    avatar: "https://optim.tildacdn.net/tild3633-6237-4263-b864-623665636437/-/cover/100x100/center/center/-/format/webp/__19.jpeg.webp"
  },
  {
    quote: "When I lost $75,000 to a cruel scam, I felt like my world was falling apart. Then I met Elizabeth and her incredible team. They knew exactly how to handle my case and gave me hope when I thought all was lost.",
    name: "Jessica Rowland",
    avatar: "https://optim.tildacdn.net/tild6464-3331-4332-b932-306434386134/-/cover/100x100/center/center/-/format/webp/__18.jpeg.webp"
  },
  {
    quote: "Working with you was not only professional but also a pleasure. Thank you for your kindness and exceptional support!",
    name: "Mark Williams",
    avatar: "https://optim.tildacdn.com/tild3366-3036-4738-b663-643464346565/-/cover/100x100/center/center/-/format/webp/__8.jpeg.webp"
  }
];

export const trustBadges = [
  { name: 'Trust Badge 1', url: 'https://optim.tildacdn.com/tild3064-3161-4161-a230-626439613131/-/resize/440x/-/format/webp/images.png.webp' },
  { name: 'Trust Badge 2', url: 'https://optim.tildacdn.com/tild3233-3665-4861-a662-306364653063/-/resize/440x/-/format/webp/images_2.png.webp' },
  { name: 'Trust Badge 3', url: 'https://optim.tildacdn.com/tild3031-6638-4237-b132-353037613964/-/resize/440x/-/format/webp/images_3.png.webp' },
  { name: 'Trust Badge 4', url: 'https://optim.tildacdn.com/tild6466-6631-4739-a162-613863343565/-/resize/440x/-/format/webp/images_4.png.webp' },
  { name: 'ConsumerAffairs', url: 'https://optim.tildacdn.com/tild6537-3630-4236-b833-366332353934/-/resize/440x/-/format/webp/consumeraffairs-vect.png.webp' }
];

export const howWeWorkColumns = [
  {
    text: "At ChargebackCanada, we are dedicated to helping you recover your stolen assets. Our team of financial experts collaborates closely with you to gather the necessary information, while our recovery specialists and legal department take action to track down and confront the scammers."
  },
  {
    text: "With years of experience, we understand how to effectively fight for your case, particularly in Binary Options, Forex, and Cryptocurrency, where we have a proven track record of success."
  },
  {
    text: "Don't hesitate—start the process today with a quick conversation to secure your stolen assets and get your life back on track."
  }
];

export const faqData = [
  {
    question: "Learn more about ChargebackCanada and the industry",
    answer: "In the modern world, where individuals almost exclusively conduct their businesses in cyberspace, online threats have become a menace that everyone has to contend with. Enemies are able to commit crimes and carry out fraud against even the most cautious. Becoming a victim is always horrible, as it involves financial and emotional ruin.\n\nThe good news is that there is light at the end of the tunnel. Thanks to the ChargebackCanada program for funds recovery, people are expressing their gratitude once again after being scammed by con artists peddling bogus goods.\n\nHaving over the years focused on foreign exchange trading, ChargebackCanada is a leading firm when it comes to the fight against scams, and assists many clients from around the world, including the UK, recover their depleted accounts. Always pay attention, and allow us to help you get back what is rightfully yours."
  },
  {
    question: "The chargeback industry",
    answer: "The chargeback industry focuses on reversing unauthorized or fraudulent financial transactions. It involves working with banks, credit card companies, and regulatory bodies to dispute charges and recover lost funds. Our team understands the complex regulations and procedures required to navigate this industry successfully.\n\nA chargeback is a directive mandated by a bank to reimburse an amount charged to a merchant, either as cooperative repurchase or dispute. Although most people purchase goods or services, requests for refunds are made as a result of discrepancies or in cases where a dishonest act has occurred.\n\nThis system is aimed at preventing consumers from being swindled and in some places is necessary to enable returning of items in case of suspected dishonesty. Nevertheless, certain retailers may design unnecessarily long processes for reimbursement in order to prevent customers from making such claims.\n\nIn essence, chargebacks are an important feature based on safety aimed at protecting the interests of consumers, who can go directly to banks to ask for the refund instead of the merchants after Internet shopping."
  },
  {
    question: "Funds recovery with ChargebackCanada",
    answer: "Our funds recovery process involves a comprehensive analysis of your case, gathering evidence, preparing documentation, and engaging with financial institutions and regulatory bodies. We use proven strategies and maintain relationships with key industry contacts to maximize your chances of recovery.\n\nChargebackCanada provides a specialized service for users who have suffered from any internet-related fraud and would like to get their money back. But what is funds recovery? It is the service offered for the scrutiny and remediation of all fraudulent activities. We help the clients to get the refunds and reimbursements by looking into the digital footprints and cyber transactions.\n\nBecause we are so good at dealing with the internet frauds, we manage to retrieve losses from:\n- Cryptocurrency frauds\n- Bitcoin deception\n- Recovery from fraud\n- Investment recovery\n\nUpon the receipt of a complaint, our team expedites the assessment of the case and the collection of evidence to facilitate successful recovery."
  },
  {
    question: "Recover from online trading scams",
    answer: "Have you incurred losses during Forex trading?\n\nAre you looking for ways to get back your losses? Most of the people have been in your shoes. It is not only you who has become a victim of online trading frauds. ChargebackCanada has a solution for that. Our specialists are able to recover money that has been lost in scams involving Forex and Crypto trading. They know the methods that the crooks employ, and most times it involves luring people from social media, and that goes for fake experts who run professional looking websites that promise mountains of returns.\n\nThese tactics should not see you suffer financial losses because of online trading scams. Get in touch with ChargebackCanada right away, and we will assist you in recovering your funds in the shortest time possible."
  },
  {
    question: "About ChargebackCanada",  
    answer: "ChargebackCanada LTD is a global leader in combating online fraud, committed to saving people from scams and helping them recover the money back. Our team of wealth recovery specialists is for sure support provided to millions of victims across the world. We ship unregulated Forex and Binary Options brokers, so the rate of success is considerable. From fraud, we managed to recover more than $16,000,000+ only in July.\n\nWe have experience in the Forex market, international banking, and cyber act law, and thus we come up with ways to enable you not to fall into recovery scams while offering refund useful services, cancellation, and other online fraudulent acts avert.\n\nTrust ChargebackCanada to help you recover your losses. Our services include:\nOnline trading scams\nRecovery of funds\nScam lottery ticket services\nRecovery from crypto scams\nRecovery from fraud cases\n\nRead testimonials on our site. Only certified companies are listed on TrustPilot. We are committed to doing business in a transparent and accountable manner. If you've lost money, reach out to us to help you get it back."
  },
  {
    question: "How Can I qualify for Chargeback?",
    answer: "If you are 18 years or older, reside in Canada, and have been defrauded of more than $2,000 through online investments, romance scams, job offers, or similar schemes, we may be able to help."
  }
];

export const countries = [
  'United States', 'Canada', 'United Kingdom', 'Australia', 'Germany', 
  'France', 'Italy', 'Spain', 'Netherlands', 'Sweden', 'Norway', 
  'Switzerland', 'Belgium', 'Austria', 'Denmark', 'Finland', 'Other'
];

export const amountRanges = [
  'Under $5,000', '$5,000 - $10,000', '$10,000 - $25,000', 
  '$25,000 - $50,000', '$50,000 - $100,000', 'Over $100,000'
];

export const stats = {
  successRate: {
    icon: 'TrendingUp',
    value: '96.7%',
    label: 'Average Success rate 2025'
  },
  casesWon: {
    icon: 'Briefcase',
    value: '2850+',
    label: 'Cases won'
  },
  fundsRetrieved: {
    icon: 'RefreshCw',
    value: '27M+',
    label: 'Funds retrieved 2025'
  }
};